class CanvasHollowInner {
  constructor(canvasObj, scale = 0.6) {
    this.canvasObj = canvasObj;
    this.scale = scale;
  }

  static getHollowInnerData(canvasObj, scale = 0.6) {
    switch (canvasObj.shape) {
      case "circle":
        return this.getCircleInnerData(canvasObj, scale);
      case "polygon":
        return this.getPolygonInnerData(canvasObj, scale);
      case "ellipse":
        return this.getEllipseInnerData(canvasObj, scale);
      case "path":
        return this.getPathInnerData(canvasObj, scale);
      case "polyline":
        return this.getPolylineInnerData(canvasObj, scale);
      default:
        return {};
    }
  }

  static getCircleInnerData(canvasObj, scale) {
    const { r } = canvasObj;
    const innerR = r * scale;

    return {
      shape: "circle",
      r: innerR
    };
  }

  static getPolygonInnerData(canvasObj, scale) {
    const data = canvasObj.polyData.split(/\s/);
    const xList = data.filter(item => item.match(",")).map(item => parseFloat(item.replace(",", "")));
    const yList = data.filter(item => !item.match(",")).map(item => parseFloat(item));

    const centerX = xList.reduce((sum, x) => sum + x, 0) / xList.length;
    const centerY = yList.reduce((sum, y) => sum + y, 0) / yList.length;

    const innerPoints = [];
    for (let i = 0; i < xList.length; i++) {
      const innerX = centerX + (xList[i] - centerX) * scale;
      const innerY = centerY + (yList[i] - centerY) * scale;
      innerPoints.push(`${innerX},${innerY}`);
    }

    return {
      shape: "polygon",
      polyData: innerPoints.join(" ")
    };
  }
  static getEllipseInnerData(canvasObj, scale) {
    const { cx, cy, rx, ry, rotate = 0 } = canvasObj;
    const innerRx = rx * scale;
    const innerRy = ry * scale;

    return {
      shape: "ellipse",
      cx: cx,
      cy: cy,
      rx: innerRx,
      ry: innerRy,
      rotate: rotate
    };
  }

  static getPathInnerData(canvasObj, scale) {
    return {
      shape: "path",
      pathData: canvasObj.pathData
    };
  }

  static getPolylineInnerData(canvasObj, scale) {
    const { points, width } = canvasObj;
    const pointArray = points.split(/\s/).map(point => {
      const [x, y] = point.split(",").map(Number);
      return { x, y };
    });

    const centerX = pointArray.reduce((sum, p) => sum + p.x, 0) / pointArray.length;
    const centerY = pointArray.reduce((sum, p) => sum + p.y, 0) / pointArray.length;

    const innerPoints = pointArray.map(point => {
      const innerX = centerX + (point.x - centerX) * scale;
      const innerY = centerY + (point.y - centerY) * scale;
      return `${innerX},${innerY}`;
    });

    return {
      shape: "polyline",
      points: innerPoints.join(" "),
      width: width * scale
    };
  }
}

export default CanvasHollowInner;